import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/ui/spinner';
import { ConsignmentHistoryEntry } from '@/entities/consignments';

import { HistoryEntry } from './history-entry';

interface HistoryListProps {
  historyData?: ConsignmentHistoryEntry[];
  isLoading: boolean;
  hasFilter: boolean;
}

export function HistoryList({ historyData, isLoading, hasFilter }: HistoryListProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  if (!hasFilter) {
    return <div className="text-center py-8 text-muted-foreground">{t('newcmr.history.list.noFilters')}</div>;
  }

  if (!historyData || historyData.length === 0) {
    return <div className="text-center py-8 text-muted-foreground">{t('newcmr.history.list.noChanges')}</div>;
  }

  return (
    <div className="space-y-3">
      {historyData.map((entry, index) => (
        <HistoryEntry key={index} entry={entry} />
      ))}
    </div>
  );
}
